import { render, staticRenderFns } from "./ErpIcmRoomAccessInfo.vue?vue&type=template&id=73924ba6&scoped=true&"
import script from "./ErpIcmRoomAccessInfo.vue?vue&type=script&lang=js&"
export * from "./ErpIcmRoomAccessInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73924ba6",
  null
  
)

export default component.exports